var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class AtlonaAmp {
    constructor(socket, log) {
        this.socket = socket;
        this.apiState = 'username';
        this.firmwareVersion = '1.1.20';
        this.power = false;
        this.volume = 50;
        this.volumeMute = false;
        this.timeouts = new Timeouts();
        this.apiAsyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /Version/i,
                callback: (match) => {
                    this.socket.send(this.firmwareVersion);
                },
            },
            {
                name: 'powerGet',
                regExp: /PW\s*sta/i,
                callback: (match) => {
                    this.socket.send(`PW${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /PW\s*(on|off)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON';
                    this.socket.send(`PW${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'volumeGet',
                regExp: /VOL\s*sta/i,
                callback: (match) => {
                    this.socket.send(`VOL ${this.volume}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /VOL (\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`VOL ${this.volume}`);
                },
            },
            {
                name: 'volumeMuteGet',
                regExp: /VOUTMute sta/i,
                callback: (match) => {
                    this.socket.send(`VOUTMute ${this.volumeMute ? 'on' : 'off'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /VOUTMute (on|off)/i,
                callback: (match) => {
                    this.volumeMute = match[1].toUpperCase() === 'ON';
                    this.socket.send(`VOUTMute ${this.volumeMute ? 'on' : 'off'}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(`Unknown command '${match[0]}'`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`Welcome to TELNET`);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Username: `);
        });
    }
}
AtlonaAmp.emulatorType = 'socketEmulator';
AtlonaAmp.key = '-N8UL7YkqI43y8-z3f_f';
